import React from 'react';
import { MapPin, Flag, LandPlot } from 'lucide-react';
import { PortfolioData } from 'src/app/portfolio/state/api/portfolioQuery';
import SummaryCard from './SummaryCard';
import ObjectiveCard from './ObjectiveCard';

const MyPortfolioSection = ({ portfolioData }: { portfolioData: PortfolioData }) => {
    return (
        <div className='flex flex-col gap-2' data-testid='portfolio-my-portfolio-section'>
            <div className='text-xl text-black' data-testid='portfolio-my-portfolio-heading'>
                My portfolio
            </div>
            <div className='grid grid-cols-3 gap-3'>
                <div className='col-span-2 flex'>
                    {/* Objectives Card */}
                    <ObjectiveCard portfolioObjective={portfolioData.objective} />
                </div>

                <div className='col-span-1 flex flex-col gap-3'>
                    <div className='flex gap-3'>
                        {/* Sites Card */}
                        <SummaryCard
                            dataTestId='portfolio-summary-sites-card'
                            cardIcon={<MapPin className='text-primary' />}
                            cardTitle='Sites'
                            cardBody={<div className='text-[42px] text-grey-80 font-normal'>{portfolioData.summary.numberSites}</div>}
                        />

                        {/* Countries Card */}
                        <SummaryCard
                            dataTestId='portfolio-summary-countries-card'
                            cardIcon={<Flag className='text-primary' />}
                            cardTitle='Countries'
                            cardBody={<div className='text-[42px] text-grey-80 font-normal'>{portfolioData.summary.countryCount}</div>}
                        />
                    </div>

                    {/* Area Card */}
                    <SummaryCard
                        dataTestId='portfolio-summary-area-card'
                        cardIcon={<LandPlot className='text-primary' />}
                        cardTitle='Area'
                        cardBody={
                            <div className='text-[42px] text-grey-80 font-normal'>
                                <span className='flex items-baseline gap-1'>
                                    {portfolioData.summary.totalArea.toFixed(2)} <span className='text-xl'>km²</span>
                                </span>
                            </div>
                        }
                    />
                </div>
            </div>
        </div>
    );
};

export default MyPortfolioSection;
